import React, { useState } from 'react';
import styles from './FaqLayout.module.css';

interface FaqLayoutProps {
	deviceCheck?: boolean;
	data: any;
    isNote: boolean;
	rate:any;
}

const FaqLayout: React.FC<FaqLayoutProps> = ({ deviceCheck, data, isNote,rate }) => {
	const [accordian, setAccordian] = useState<number | null>(null);

	const toggle = (id: number) => {
		setAccordian(accordian === id ? null : id);
	};

	return (
		<>
			<div className={styles.Faq}>
				<div className={styles.FaqTitle}>FAQs</div>
				<div className={styles.FaqWrap}>
					<ul className={styles.FaqList}>
						{data?.map((item: any, index: any) => (
							<FaqList id={index} key={index} TabName={item.title} TabDescription={item.description} accordian={accordian} toggle={toggle} />
						))}
					</ul>
				</div>
			</div>
            {
                isNote &&
                <div className={styles.AstickNote}>
                    * Subject to Meta Approval <span className={styles.textSemibold}>*{rate} per WhatsApp message</span> <span className={styles.textLightgray}>(*Subject to WhatsApp policies)</span>.
                </div>
            }
		</>
	);
};

interface FaqListProps {
	id: number;
	TabName: string;
	TabDescription: string;
	accordian: number | null;
	toggle: (id: number) => void;
}

const FaqList: React.FC<FaqListProps> = ({ id, TabName, TabDescription, accordian, toggle }) => {
	return (
		<li className={`${styles.FaqListItem} ${accordian === id ? styles['show'] : ''}`}>
			<div className={`${styles.FaqListTitle}`} onClick={() => toggle(id)}>
				{TabName}
			</div>

			{accordian === id && <div className={styles.FaqListText}>{TabDescription}</div>}
		</li>
	);
};

export default FaqLayout;
